module.exports = __webpack_public_path__ + "img/constructe.7c31a208.png";